import Cookies from 'universal-cookie';

export const DeleteCookie = (cookieName) => {
  try {
    const cookie = new Cookies();
    cookie.remove(cookieName);
  } catch (error) {
    throw error;
  }
};

export const SetCookie = (cookieName, data) => {
  try {
    const cookie = new Cookies();
    cookie.set(cookieName, data);
  } catch (error) {
    throw error;
  }
};

export const GetCookie = (cookieName) => {
  try {
    const cookie = new Cookies();
    return cookie.get(cookieName);
  } catch (error) {
    return null;
  }
};